import { render, staticRenderFns } from "./getontheseanew.vue?vue&type=template&id=2cf44c54&scoped=true&"
import script from "./getontheseanew.vue?vue&type=script&lang=js&"
export * from "./getontheseanew.vue?vue&type=script&lang=js&"
import style0 from "./getontheseanew.vue?vue&type=style&index=0&id=2cf44c54&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf44c54",
  null
  
)

export default component.exports